import { render, staticRenderFns } from "./RelativeAlbum.vue?vue&type=template&id=251f05e6"
import script from "./RelativeAlbum.vue?vue&type=script&lang=js"
export * from "./RelativeAlbum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports